<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'SetNewPassword',
  data() {
    return {
      success: null,
    };
  },
  computed: {
    ...mapState('user', [
      'user',
      'errors',
    ]),
    confirmationToken: {
        get() {
          return this.user.confirmationToken;
        },
        set(value) {
          const { user } = this;
          user.confirmationToken = value;
          this.setUser(user);
        },
    },
    password: {
        get() {
          return this.user.password;
        },
        set(value) {
          const { user } = this;
          user.password = value;
          this.setUser(user);
        },
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchChangePassword',
    ]),
    ...mapMutations('user', [
      'setUser',
    ]),
    changePassword() {
      this.fetchChangePassword()
        .then(res => {
          if (res) {
            this.success = true;
            setTimeout(() => {
              this.$router.push({ name: 'login' });
            }, 3000);
          }
        })
    },
  },
  created() {
    this.confirmationToken = get(this, '$route.params.token', null);
  },
};
</script>
<template>
    <div id="setNewPassword" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5">
            <h1 class="text-center">Ustaw Nowe Hasło</h1>
        </div>
        <div id="login" class="text-center">
            <div class="wrapper text-left">
                <div class="container d-flex flex-column">
                    <h2>Wpisz swoje nowe hasło</h2>
                    <label for="password">Nowe Hasło</label>
                    <input id="password" class="mb-3" v-model="password" />

                    <label for="confirmationToken">Token Potwierdzenia</label>
                    <input id="confirmationToken" v-model="confirmationToken" />

                    <div class="errors" v-if="errors.length > 0">
                        <div v-for="error in errors">{{ error }}</div>
                    </div>

                    <div class="alert-success mt-3 p-3" v-if="success">
                        Powodzenie! Twoje hasło zostało zmienione!
                        <br>
                        Teraz możesz zalogować się za pomocą nowego hasła!
                    </div>

                    <div class="text-center">
                        <button @click="changePassword">
                            Ustaw Nowe Hasło
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
